export default {
  name: 'Pitcairn',
  phonePattern: '',
  postalCodePattern: '',
  singlePostalCode: 'PCRN1ZZ',
  postalCodeRegex: '^(PCRN1ZZ)$',
  language: '',
  dobFormat: 'DD MM YY',
  countryPrefix: '64'
}



// WEBPACK FOOTER //
// ./src/locales/countries/PN.js